import React from 'react';
import { Provider } from 'react-redux';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/fr';

import store from './store';

import AppLayout from './components/AppLayout';
import AnalyticsComponent from './components/AnalyticsComponent';
import { ConfigProvider } from 'antd';

moment.locale('fr');
moment.tz.setDefault('Europe/Paris');

function App() {
  return (
    <div className="App">
      <ConfigProvider
        // use https://ant.design/theme-editor#Color to customize
        theme={{
          "token": {
            "colorPrimary": "#1089ff",
            "colorInfo": "#1089ff",
            "colorLink": "#1089ff"
          },
          "components": {
            "Menu": {
              "darkItemBg": "#001147"
            }
          },
        }}
      >
        <Provider store={store}>
          <Router>
            <AnalyticsComponent>
              <Routes>
                <Route path="/*" element={<AppLayout />} />
              </Routes>
            </AnalyticsComponent>
          </Router>
        </Provider>
      </ConfigProvider>
    </div>
  );
}

export default App;
